import { render, staticRenderFns } from "./AllDisputes.vue?vue&type=template&id=aa0c8980&"
import script from "./AllDisputes.vue?vue&type=script&lang=js&"
export * from "./AllDisputes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports